import { call, put, takeLatest } from 'redux-saga/effects';

import {
  getLicenseTypes,
  getLicenseTypesOgaStatuses,
  type TLicenseTypesResponse,
  type TOgaStatus,
} from '../../services/licenseTypeApiService';

import { LicenseTypeNature } from '../../types';

import { setLicenseTypes, setLicenseTypesLoading, setOgaStatuses, setOgaStatusesLoading } from './slice';
import * as actions from './actions';

function* getLicenceTypes({ payload }: ReturnType<typeof actions.getLicenseTypes>) {
  const { licenseTypeNature = LicenseTypeNature.LPCO } = payload;

  try {
    yield put(setLicenseTypesLoading({ loading: true, licenseTypeNature }));

    const { data } = yield call(getLicenseTypes, payload);
    yield put(
      setLicenseTypes({
        data: (data as TLicenseTypesResponse).resultList,
        licenseTypeNature,
      })
    );
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setLicenseTypesLoading({ loading: false, licenseTypeNature }));
  }
}

function* getOgaStatuses() {
  try {
    yield put(setOgaStatusesLoading(true));

    const { data } = yield call(getLicenseTypesOgaStatuses);
    yield put(setOgaStatuses(data as TOgaStatus[]));
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setOgaStatusesLoading(false));
  }
}

export default function* watchLicenseTypeSaga() {
  yield takeLatest(actions.getLicenseTypes, getLicenceTypes);
  yield takeLatest(actions.getOgaStatuses, getOgaStatuses);
}
